exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".container-1c79ae42{position:relative;display:inline-block}.flair-ebc076aa{color:#FA6400;background:#fff;border-radius:50%;border:solid 2.5px #FA6400;position:absolute;bottom:-12%;right:-12%}\n", ""]);

// Exports
exports.locals = {
	"container": "container-1c79ae42",
	"flair": "flair-ebc076aa"
};